import gql from "graphql-tag";

export default gql`
	mutation showOverlay($url: String) {
		route(url: $url) @client
	}
`;
